import { serviceClient, utils } from '@yola/ws-sdk';

const POLLING_INTERVAL = 3000;

const initiatePageGeneration = async ({ locale, recipeId, name, userInput }) => {
  const client = serviceClient.get();
  const response = await client.initiatePageGeneration({
    locale,
    recipeId,
    pageName: name,
    userInput,
  });
  const {
    data: { id: jobId },
  } = response;

  return utils.pollAsyncJob({ jobId, interval: POLLING_INTERVAL });
};

export default initiatePageGeneration;
